import { Router } from "@angular/router";
import { Observable, of } from "rxjs";

import { AccountService } from "@bitwarden/common/auth/abstractions/account.service";
import {
  Region,
  RegionConfig,
  Urls,
} from "@bitwarden/common/platform/abstractions/environment.service";
import {
  getMavenInjectServerUrls,
  MAVENINJECT_SERVER_URL,
  MAVENINJECT_REGION_CONFIG,
} from "@bitwarden/common/platform/services/maveninject-environment";
import { SelfHostedEnvironment } from "@bitwarden/common/platform/services/default-environment.service";
import { StateProvider } from "@bitwarden/common/platform/state";

import { WebEnvironmentService } from "./web-environment.service";

/**
 * Web-vault environment service for MavenInject.
 *
 * The web vault may be served from a different origin during packaging or
 * migration, but its API and identity requests must always target MavenInject.
 */
export class MavenInjectWebEnvironmentService extends WebEnvironmentService {
  override cloudWebVaultUrl$: Observable<string> = of(MAVENINJECT_SERVER_URL);

  constructor(
    win: Window,
    stateProvider: StateProvider,
    accountService: AccountService,
    router: Router,
  ) {
    super(
      win,
      stateProvider,
      accountService,
      [MAVENINJECT_REGION_CONFIG],
      router,
      getMavenInjectServerUrls(),
    );
  }

  override availableRegions(): RegionConfig[] {
    return [MAVENINJECT_REGION_CONFIG];
  }

  /** Never let stale or caller-provided state select another environment. */
  override buildEnvironment(_region: Region, _urls: Urls) {
    return new SelfHostedEnvironment(getMavenInjectServerUrls());
  }

  /** Ignore all requested region changes and retain the fixed server. */
  override async setEnvironment(_region: Region | string, _urls?: Urls): Promise<Urls> {
    return getMavenInjectServerUrls();
  }
}
